module.exports = __webpack_public_path__ + "img/IMG_2511.dfd71d95.jpg";